import PropTypes from 'prop-types'
import React from 'react'

import About from './articles/about'
import Skills from './articles/skills'
import Contact from './articles/contact'
import Project from './articles/project'

const Main = ({route, article, articleTimeout, onCloseArticle, redirectClick, timeout, setWrapperRef})=> {

  let close = (<div className="close" onClick={() => { onCloseArticle()}}></div> )

  return (
    <div ref={setWrapperRef} id="main" style={timeout ? { display: 'flex' } : { display: 'none' }}>
      <Skills article={article} articleTimeout={articleTimeout } redirectClick={redirectClick} close={close}/>
      <Contact article={article} articleTimeout={articleTimeout } redirectClick={redirectClick} close={close}/>
      <About article={article} articleTimeout={articleTimeout } redirectClick={redirectClick} close={close}/>
      <Project article={article} articleTimeout={articleTimeout } redirectClick={redirectClick} close={close}/>
    </div>
  )
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  redirectClick: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
